import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Sheet, Button, Icon } from '@sm/wds-react';
import classNames from 'classnames';
import { SMHeaderContext } from '../SMHeaderContext';
import MobileMenuAuthed from './MobileMenuAuthed';
import MobileMenuAnon from './MobileMenuAnon';

import './mobile-menu.scss';

const MobileMenu = ({
  isDrawerOpen,
  mobileMenuColor,
  parentToggleDrawer = () => null
}) => {
  const headerContext = useContext(SMHeaderContext);
  const { lang, user, isEUDC, isUserAuthenticated } = headerContext;

  const toggleDrawer = () => {
    parentToggleDrawer();
  };

  const buttonClass = classNames(
    'sm-mobile-menu__trigger',
    `sm-mobile-menu__cta`,
    `sm-mobile-menu--${mobileMenuColor}`,
    `wds-float--left`
  );

  return (
    <>
      <Button
        variant="text"
        size="sm"
        className={buttonClass}
        onClick={toggleDrawer}
      >
        <Icon>{isDrawerOpen ? 'å' : 'm'}</Icon>
      </Button>
      <Sheet
        show={isDrawerOpen}
        onClose={toggleDrawer}
        placement="left"
        offsetTop={50}
      >
        <Choose>
          <When condition={isUserAuthenticated}>
            <MobileMenuAuthed lang={lang} user={user} isEUDC={isEUDC} />
          </When>
          <Otherwise>
            <MobileMenuAnon lang={lang} isEUDC={isEUDC} />
          </Otherwise>
        </Choose>
      </Sheet>
    </>
  );
};

MobileMenu.propTypes = {
  isDrawerOpen: PropTypes.bool,
  mobileMenuColor: PropTypes.oneOf(['alt', 'secondary']),
  parentToggleDrawer: PropTypes.func.isRequired
};

MobileMenu.defaultProps = {
  isDrawerOpen: false,
  mobileMenuColor: 'alt'
};

export default MobileMenu;
